import { render, staticRenderFns } from "./studentMain.vue?vue&type=template&id=10ac1e25&scoped=true"
import script from "./studentMain.vue?vue&type=script&lang=js"
export * from "./studentMain.vue?vue&type=script&lang=js"
import style0 from "./studentMain.vue?vue&type=style&index=0&id=10ac1e25&prod&lang=scss&scoped=true"
import style1 from "./studentMain.vue?vue&type=style&index=1&id=10ac1e25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac1e25",
  null
  
)

export default component.exports